import { BnAction } from '../../common/bn-action';

class BinMoveAction extends BnAction {
  constructor() {
    super();
    this.actionname = 'move-bin';
    this.suppressheader = true;
    this.submittext = 'Move';
    this.suppressflash = true;
    this.showdisabled = true;
  }
}

window.customElements.define('bin-move-action', BinMoveAction);
